module.exports = "/_next/static/images/ru-e2037a0ebc084965c2c2744c68bd5837.svg";